<template>
    <div id="container">
        <template>
        <ul class="activitys">
            <li v-for="item in activitys" :key="item.ActivityId">
                <div class="img-box" v-if="item.Type===0 || item.ActivityId===20">
                    <img :src="item.Picture" @click="navigatorTo(item.ActivityId,0)" />
                </div>
                <div class="img-box" v-else>
                    <img :src="item.Picture" />
                </div>

                <div @click="navigatorTo(item.ActivityId,0)" class="text-box" v-if="item.Type===0 || item.ActivityId===20">
                    <h4>{{item.Title}}</h4>
                    <!-- <div class="information">
                        <span class="status">{{item.Status}}</span>
                        <span class="more">查看成绩</span>
                    </div> -->
                </div>
                <div class="text-box" v-else>
                    <div v-for="x in item.ScenceList" :key="x.ScenceId">
                        <h4 @click="navigatorTo(x.ActivityId,x.ScenceId)">{{x.Title}}</h4>
                    </div>
                </div>
            </li>
        </ul>
        </template>
        <template>
        <div class="nothing-box" v-if="activitysCount===0">
            <img src="@/assets/images/rank_nothing.png" />
            <p>No Ongoing Competitions Now.</p>
        </div>
        </template>
    </div>
</template>

<script>
import { getRankIndex } from '@/api/index_en.js'
export default {
    name: 'RankIndex',
    data () {
    return {
      activitysCount: 0,
      activitys: []
    }
  },
  methods: {
    // 获取进行中活动
    async initGetActivitys () {
        const { data: res } = await getRankIndex()
        if (res.errcode === 0) 
        {
            this.activitys = res.data
        }
        this.activitysCount=this.activitys.length
    },

    // 跳转至详情页
    navigatorTo (ActivityId,ScenceId) {
        this.$router.push({ path: '/en/rank/detail/' + ActivityId+'/'+ScenceId })
    },
  },
  created () {
    document.title = 'Real-time Results of Shanghai Citizen Jiu Zi Competition'
    this.initGetActivitys ()
  }
}
</script>

<style>
@import url('@/assets/css_en/app.css');
</style>
<style lang="less" scoped>
#container {
    width: 100%;
    height: 100vh;
    padding: 15px 15px 45px 15px;
    box-sizing: border-box;
    background: #F2F4F7;
    overflow-y: auto;

    ul.activitys {
        width: 100%;

        li {
            list-style: none;
            margin-bottom: 15px;
            background: #fff;
            border-radius: 10px;

            .img-box {
                width: 100%;
                border-top-right-radius: 10px;
                border-top-left-radius: 10px;

                img {
                    width: 100%;
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;
                }
            }

            .text-box {
                padding: 0 1.1rem;

                h4 {
                    margin: 0;
                    padding: 0;
                    font-size: 1rem;
                    font-weight: 500;
                    padding: 1rem 0;
                    border-bottom: #eee solid 1px;
                }

                .information {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    // margin-bottom:.2em;

                    span.status {
                        background: #f0f0f0;
                        color: #414141;
                        font-size: .75rem;
                        display: block;
                        height: 26px;
                        line-height: 26px;
                        padding: 0 15px;
                        border-radius: 5px;
                    }

                    span.more {
                        background:url(@/assets/images/rank_arrow.png);
                        background-repeat: no-repeat;
                        background-position: right;
                        background-size: auto 45%;
                        color: #111;
                        font-size: .75rem;
                        display: block;
                        height: 26px;
                        line-height: 26px;
                        padding-right:16px;
                    }
                }
            }
        }
    }

    .nothing-box {
        padding-top: 8rem;
        img {
            width: 90%;
            margin:0 auto;
        }
        p {
            text-align: center;
            font-size: .75rem;
            font-weight:300;
            padding: 0;
            margin: 0;
        }
    }
}
</style>